import { Currency } from "@/models/Currency";
import actions from "./actions";
import mutations from "./mutations";

const details: Currency = new Currency();

const state = {
  details,
  isLoading: false,
  isSnackBarVisible: false,
  snackbarMsg: "",
  snackbarStatus: "",
  dialogVisible: false,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
